<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'acompanhamentosBimestrais',
                })
            "
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Acompanhamento Bimestral Do Plano de Aula
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="gestaoDeAula" class="mb-6">
        <v-card color="green lighten-1" outlined>
          <v-col cols="10">
            <v-card-text>
              <h4>
                Professor:
                {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[carregando...]" }}
              </h4>
              <h4>Turma: {{ gestaoDeAula.turma?.descricao }}</h4>
              <h4>
                Disciplina:
                {{
                  gestaoDeAula.is_polivalencia === 1
                    ? gestaoDeAula.disciplinas.find((disciplina) => disciplina.id === disciplina_id)
                        ?.descricao || "Disciplina não encontrada"
                    : gestaoDeAula.disciplina.descricao
                }}
              </h4>

              <h4>
                Série:
                {{
                  gestaoDeAula.turma ? gestaoDeAula.turma.series[0].descricao : "[carregando...]"
                }}
              </h4>
              <h4>
                Modalidade:
                {{ gestaoDeAula.turma ? gestaoDeAula.turma.modalidade : "[carregando...]" }}
              </h4>
            </v-card-text>
          </v-col>
        </v-card>
      </v-col>
    </v-row>
    <ValidationObserver v-slot="{ handleSubmit }" v-if="!loading">
      <form @submit.prevent="handleSubmit(saveData)">
        <e-label><strong>Bimestres Confirmados</strong></e-label>
        <v-row>
          <v-col v-for="(item, index) in $constants.bimestres" :key="index" cols="12" sm="4" md="2">
            <v-checkbox
              :label="item.desc"
              :value="item.value"
              v-model="form.bimestres"
              dense
              multiple
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-col cols="12" class="mt-5">
          <v-btn block color="primary" :loading="submitting" type="submit">Salvar</v-btn>
        </v-col>
      </form>
    </ValidationObserver>
    <v-row v-else>
      <v-col cols="12">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
          <v-skeleton-loader
            class="mx-auto"
            max-width="100%"
            height="100"
            type="paragraph"
          ></v-skeleton-loader>
          <v-skeleton-loader
            class="mx-auto"
            max-width="100%"
            height="100"
            type="paragraph"
          ></v-skeleton-loader
          ><v-skeleton-loader
            class="mx-auto"
            max-width="100%"
            height="100"
            type="paragraph"
          ></v-skeleton-loader
          ><v-skeleton-loader
            class="mx-auto"
            max-width="100%"
            height="100"
            type="paragraph"
          ></v-skeleton-loader>
        </v-sheet>
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import ELabel from "../../../components/ELabel.vue";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    gestaoDeAulaId: {
      type: [String, Number],
      require: true,
    },
  },
  async mounted() {
    this.loadingPlano = true;
    await this.loadData().then(() => {
      this.loadingPlano = false;
    });
  },
  data() {
    return {
      submitting: false,
      loading: true,
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
        disciplinas: [],
      },
      loadingPlano: true,
      form: {
        bimestres: [],
        instrutor_id: null,
        turma_id: null,
        disciplina_id: null,
      },
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    disciplina_id() {
      return parseInt(this.$route.params.disciplinaId, 10);
    },
    gestao_de_aula_id() {
      return parseInt(this.$route.params.gestaoDeAulaId, 10);
    },
  },
  methods: {
    async saveData() {
      this.submitting = true;
      try {
        this.form.instrutor_id = this.gestaoDeAula.professor?.id;
        this.form.turma_id = this.gestaoDeAula.turma?.id;
        this.form.disciplina_id = this.disciplina_id;
        this.form.configuracao_id = this.gestaoDeAula.turma.franquia.id;

        await this.$services.acompanhamentosService.createOrUpdateBimestral(this.form);
        this.$toast.success("Dados salvos com sucesso!");
        this.$router.push({ name: "acompanhamentosBimestrais" });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.submitting = false;
      }
    },
    async loadData() {
      try {
        this.gestaoDeAula = await this.$services.gestoesDeAulasService.visualizar(
          this.gestao_de_aula_id
        );
        const response = await this.$services.acompanhamentosService.pegarDadosBimestral(
          this.gestao_de_aula_id,
          this.disciplina_id
        );
        if (response) {
          this.form.bimestres = response.bimestres || [];
        }
        // if (this.gestaoDeAula.disciplinas.length > 0) {
        //   const disciplina = this.gestaoDeAula.disciplinas.filter((i) => {
        //     return i.id === this.disciplina_id;
        //   });
        //   this.gestaoDeAula.disciplina = disciplina[0].descricao;
        // }
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
